module.exports = __webpack_public_path__ + "prod/1.42.2/img/yycj_two.4ef4faa6.png";